<script setup lang="ts">
import { useDisplay } from 'vuetify';
import { useRoute } from 'vue-router';
import MenuBtn from '@/features/header/MenuBtn.vue';
import LanguageBtn from '@/features/language/LanguageBtn.vue';
import DrawerBtn from '@/features/mobile/drawer/DrawerBtn.vue';
import InvitationBtn from '@/features/network/InvitationBtn.vue';
import { useNavigation } from '@/hooks/useNavigation';
import { desktopHeaderNavItems } from '@/router/navigation';

const { mobile } = useDisplay();
const route = useRoute();
const { availableItems } = useNavigation(desktopHeaderNavItems);
</script>

<template>
  <header class="md:px-5 flex justify-center h-16 border-b">
    <div class="px-5 flex justify-between w-full">
      <div class="flex gap-5">
        <router-link to="/" class="flex items-center md:ms-8">
          <VImg
            :aria-label="$t('accessibility.link.home')"
            role="button"
            alt=""
            :src="$assets('img/favicon-2023.png')"
            width="48px"
          />
        </router-link>

        <nav
          v-if="!mobile && route.name !== 'public_profile'"
          class="flex items-center"
          show-arrows
          :height="72"
        >
          <RouterLink
            v-for="(item, index) in availableItems"
            :key="index"
            :to="item.route as string"
            active-class="border-b-2 border-[#FF2F92]"
            :class="[
              'capitalize text-body-2 font-regular flex gap-2 h-full items-center hover:bg-[#F1F3F4] px-5 py-3',
              'font-sans',
            ]"
          >
            <VIcon :icon="item.icon" />
            {{ $t(item.label) }}
          </RouterLink>
        </nav>
      </div>

      <div class="flex items-center gap-7">
        <InvitationBtn />
        <LanguageBtn v-if="!mobile" />
        <MenuBtn v-if="!mobile" />
        <DrawerBtn v-if="mobile" class="md:me-4" />
      </div>
    </div>
  </header>
</template>
